<template>
</template>

<script>
  export default {
    props: {
      invoice: Object,
    },
    methods: {
      getTransition(state) {
        return this.invoice.canTransitionTo.find(item => item.split('\\').pop() === state);
      },
      action(object) {
        this.$emit('action', object);
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
